import { viewport } from '@tivio/common'
import React from 'react'
import styled from 'styled-components'

import { ENV } from '../env'

import { useAppConfig } from './hooks/useAppConfig'


const Logo = styled.img`
    max-height: ${155 * viewport.scaling}px;
    margin: auto;
`

const DebugWarning = styled.h1`
    position: fixed;
    top: 100px;
    right: 200px;
    color: #ff862f;
    font-family: Sans;
    font-size: 2em;
`
type BackgroundProps = {
    splashScreenBackgroundColor?: string
}

const Background = styled.div<BackgroundProps>`
    background-color: ${props => props.splashScreenBackgroundColor ? props.splashScreenBackgroundColor : 'black'};
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`

const SplashScreen: React.FC = () => {
    const { config } = useAppConfig()

    return (
        <>
            <Background splashScreenBackgroundColor={config.splashScreenBackgroundColor}>
                <Logo
                    src={config.logo}
                    alt="App splash screen logo"
                />
            </Background>
            {ENV.IS_DEBUG && <DebugWarning>DEBUG VERSION</DebugWarning>}
        </>
    )
}

export {
    SplashScreen,
}
